// Allay (M18.1-adjacent). PURE (ENG-1). The friendly flyer's rules: it likes the
// item a player hands it and fetches matching drops, it dances when a note block
// plays nearby, and — dancing, handed an amethyst shard, off cooldown — it
// duplicates itself. The AI/movement is the host's; these are the gates.
import { ALLAY } from '../config';

/** An allay accepts (holds/seeks) any real item a player hands it. */
export function allayLikes(handed: string): boolean {
  return handed !== '' && handed !== 'air';
}

/** An allay holding `held` picks up a matching dropped item within range. */
export function allayPicksUp(dropped: string, held: string, dist: number): boolean {
  return held !== '' && dropped === held && dist <= ALLAY.PICKUP_RANGE;
}

/** Range an allay collects a matching dropped item within. */
export function allayPickupRange(): number {
  return ALLAY.PICKUP_RANGE;
}

/** An allay dances when a note block is playing nearby — the duplication window. */
export function allayDances(noteBlockNear: boolean): boolean {
  return noteBlockNear;
}

/** A dancing allay handed an amethyst shard duplicates, if its cooldown is ready. */
export function allayDuplicates(dancing: boolean, gaveAmethyst: boolean, cooldownReady: boolean): boolean {
  return dancing && gaveAmethyst && cooldownReady;
}

/** Ticks before a (freshly-duplicated) allay may duplicate again. */
export function allayDupCooldownTicks(): number {
  return ALLAY.DUP_COOLDOWN_TICKS;
}
